import React, { useState, Fragment, useContext, useEffect } from "react";
import { UserContext } from "../../context/UserContext";
import { isEmpty } from "../../common/Common";
import { SearchIcon } from "../../common/CustomIcon";
import { Button } from "antd";
import _ from "lodash";
import AppConfig from "../../config/AppConfig";

const GlobalSearchHint = (props) => {
  const userContext = useContext(UserContext);
  const { updateScreenConfig, currentUser } = userContext;
  const [showHint, setShowHint] = useState(false);

  useEffect(() => {
    const showHintConfig = _.get(
      currentUser,
      `screen_config.global_search.show_global_search_hint`,
      true
    );
    setShowHint(isEmpty(showHintConfig) ? true : showHintConfig);
  }, [currentUser]);

  const handleDismiss = () => {
    setShowHint(false);
    updateScreenConfig("global_search", false, "show_global_search_hint");
  };

  const handleLearnMore = () => {
    window.open(AppConfig.academyGlobalSearchUrl, "_blank");
  };

  if (!showHint) {
    return  <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        color: '#8897A4',
        fontFamily: 'Lato',
        fontSize: '14px',
        fontWeight: '700',
        paddingTop: 0
      }}>
        Items you've selected in the past will show here.
      </div>;
  }

  return (
    <>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        color: '#8897A4',
        fontFamily: 'Lato',
        fontSize: '14px',
        fontWeight: '700',
        paddingTop: 0
      }}>
        Items you've selected in the past will show here.
      </div>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      padding: '40px 2px',
      position: 'relative',
    }}>
      <div style={{
        position: 'relative',
        width: '100%',
        height: '180%',
        maxWidth: '500px',
        padding: '24px',
        background: '#273156',
        borderRadius: '12px',
        border: '1px solid #DDE5EB',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <div style={{
          position: 'absolute',
          top: '24px',
          right: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <SearchIcon color="#fff" style={{ fontSize: 24}} />
        </div>

        <div style={{
          color: '#fff',
          fontFamily: 'Poppins',
          fontSize: '14px',
          fontWeight: 600,
          lineHeight: '24px',
          marginBottom: '12px',
          paddingRight: '40px',
        }}>
          Find things faster with the new Global Search!
        </div>

        <div style={{
          color: '#fff',
          fontFamily: 'Lato',
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: '20px',
          marginBottom: '2px',
          paddingRight: '40px',
          whiteSpace: 'pre-line'
        }}>
          <p>{` Search across orders, invoices, billings, accounts, drivers, equipment,
          and quotes all from one place. Start typing for instant results with a
          preview of each item in the side bar. Navigate with ↑↓ arrow keys,
          press ↵ enter/return to open the result. Reopen search at anytime to 
          see your last clicked on results for those persistent needs.`}</p>
        </div>

        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '12px'
        }}>
          <Button
            type="link"
            onClick={handleDismiss}
            style={{
              color: '#ACB7E6',
              fontFamily: 'Lato',
              fontSize: '14px',
              fontWeight: 600,
              padding: '0',
              height: 'auto'
            }}
          >
            Dismiss Tip
          </Button>

          <Button
          type="link"
          onClick={handleLearnMore}
          style={{
            color: '#ACB7E6',
            fontFamily: 'Lato',
            fontSize: '14px',
            fontWeight: 600,
            padding: '0',
            height: 'auto'
          }}
        >
            Learn More
          </Button>
        </div>
      </div>
    </div>
    </>
  );
};

export default GlobalSearchHint;
